import { __awaiter, __generator } from "tslib";
import { MEDIA_SERVICES_URL } from '@wix/ricos-common';
export function uploadMediaFile(instance) {
    var _this = this;
    return function (file, type, privacy) {
        if (privacy === void 0) { privacy = 'public'; }
        return __awaiter(_this, void 0, void 0, function () {
            var params, response, _a, uploadUrl_1, uploadToken, formData_1, request_1, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        params = new URLSearchParams({ mediaType: type, privacy: privacy });
                        return [4 /*yield*/, fetch(MEDIA_SERVICES_URL + "/upload-url?" + params.toString(), {
                                headers: { Authorization: instance },
                            })];
                    case 1:
                        response = _b.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        _a = _b.sent(), uploadUrl_1 = _a.uploadUrl, uploadToken = _a.uploadToken;
                        formData_1 = new FormData();
                        formData_1.append('file', file, file.name);
                        formData_1.append('upload_token', uploadToken);
                        formData_1.append('media_type', type);
                        formData_1.append('acl', privacy);
                        request_1 = new XMLHttpRequest();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                try {
                                    request_1.responseType = 'json'; // IE11 does not support responseType json
                                }
                                catch (e) { }
                                request_1.addEventListener('load', function (event) {
                                    var eventTarget = event.target;
                                    var data = eventTarget === null || eventTarget === void 0 ? void 0 : eventTarget.response[0];
                                    var error_description = (eventTarget === null || eventTarget === void 0 ? void 0 : eventTarget.response).error_description;
                                    if (error_description) {
                                        reject(eventTarget.response);
                                    }
                                    try {
                                        data = JSON.parse(eventTarget === null || eventTarget === void 0 ? void 0 : eventTarget.response)[0];
                                    }
                                    catch (e) { }
                                    resolve(data);
                                });
                                request_1.addEventListener('error', reject);
                                request_1.open('POST', uploadUrl_1);
                                request_1.send(formData_1);
                            })];
                    case 3:
                        err_1 = _b.sent();
                        throw err_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
}
//# sourceMappingURL=mediaManagerService.js.map